import { useTranslation } from 'react-i18next';
import type { IMessage } from '@interfaces/ISubcontractorPortal';
import { formatRelative } from '../subcontractors.format';
import styles from './MessagesCoordination.module.css';

export function MessagesCoordination({ messages, tz }: { messages: IMessage[]; tz: string }) {
  const { t } = useTranslation();
  const pendingCount = messages.filter((m) => m.needsResponse).length;

  return (
    <section className={styles.panel}>
      <header className={styles.head}>
        <div className={styles.headLeft}>
          <h3 className={styles.title}>{t('subcontractors.messages.title')}</h3>
          <p className={styles.subtitle}>{t('subcontractors.messages.subtitle')}</p>
        </div>
        <span className={styles.pending}>
          {t('subcontractors.messages.pending', { count: pendingCount })}
        </span>
      </header>
      <ul className={styles.list}>
        {messages.map((m) => (
          <li key={m.id} className={styles.card} data-pending={m.needsResponse}>
            <div className={styles.cardHead}>
              <span className={styles.avatar} aria-hidden="true">
                {m.fromInitials}
              </span>
              <div className={styles.identity}>
                <span className={styles.fromName}>{m.fromName}</span>
                <span className={styles.fromRole}>{m.fromRole}</span>
              </div>
              <span className={styles.timestamp}>{formatRelative(m.timestamp, tz)}</span>
            </div>
            <p className={styles.body}>{m.body}</p>
            {m.needsResponse ? (
              <div className={styles.actions}>
                <button type="button" className={styles.respond}>
                  {t('subcontractors.messages.respond')}
                </button>
                <button type="button" className={styles.snooze}>
                  {t('subcontractors.messages.snooze')}
                </button>
              </div>
            ) : (
              <span className={styles.resolved}>
                {t('subcontractors.messages.resolved')}
              </span>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
